import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Urbanist'].join(','),
  },
  overrides: {
    MuiTableCell: {
      stickyHeader: {
        fontWeight: '600 !important',
      },
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: '#22C0E7',
      },
    },
    MuiTab: {
      wrapper: {
        fontWeight: '600 !important',
      },
    },
    MuiTypography: {
      body1: {
        fontWeight: '600 !important',
      },
    },
  },
});

export default theme;
